export default __webpack_public_path__ + "static/media/map_mode_green.0cf0663d.svg";